import {DataFetcher} from '@aboutyou/data-fetcher';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React from 'react';
import {useLegalReportSection} from '../useGetProductBulkSection';
import {LegalReportView} from './LegalReportView';

export const LegalReport: React.FC<{
  className?: string;
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
}> = props => {
  return (
    <DataFetcher
      request={useLegalReportSection()}
      Error={null}
      View={LegalReportView}
      viewProps={props}
    />
  );
};
